export const inclSearchParams = (path, searchParamString) =>
  `${path}${searchParamString}`;
